import axios from 'axios';
import store from "@/store";

const qs = require('querystring');

class ChatService {
    baseUrl = process.env.VUE_APP_PWS_BASE_URL
    store
    conn
    isRefreshing = false
    languageEquivalences = {
        'en': 'en',
        'es': 'sp'
    }
    threadRefreshCallback = null

    constructor(store) {
        this.store = store;
        //this.getSocket();
    }

    getThreadData(action) {
        var data = {
            thread: this.store.state.id,
            token: this.store.state.token,
            lastid: this.store.state.lastId,
            locale: this.store.state.language,
            user: true,
        };
        if (action) {
            data.act = action;
        }
        return data;
    }

    refreshThread() {
        if (this.store.state.id && this.store.state.token) {
            if (!this.isRefreshing) {
                this.isRefreshing = Date.now();
                this.sendRequest('refresh');

            } else {
                //@TODO poor internet connection (difference between current and last call)
            }
        } else {
            this.stopThreadRefresh();
        }
    }

    postMessage(message) {
        this.isRefreshing = Date.now();
        this.sendRequest('post', message);

    }

    sendRequest(action, content) {

        var data = this.getThreadData(action);

        if (content) {
            switch (action){
                case "post":
                    data.message = content;
                    break;
                case "shareUrl":
                    data.url = content;
                    break;
            }
        }

        if(this.conn) {
            this.conn.send( JSON.stringify({"action":action,"data":data}));
        }
        else {
            return axios.post(
                this.baseUrl + 'thread.php?content_type=json&t=' + action,
                qs.stringify(data)
            ).then((response) => {
                var respData = response.data;
                this.serverResponse(respData);
            }).finally(() => {
                this.isRefreshing = false;
            });

        }
    }

    checkSocketConnecion(){
        if (!this.conn){
            return this.getSocket();
        }else if (this.conn.readyState == this.conn.CLOSED || this.conn.readyState == this.conn.CLOSING){
            this.conn.close();
            this.conn = null;
        }
        return this.conn;
    }

    getSocket(){

        if (!this.conn && window["WebSocket"]) {
            this.conn = new WebSocket("wss://devserver-es.deswebislas.com:9502/wss/");
//            this.conn = new WebSocket("ws://127.0.0.1:9502/ws/");
            this.conn.onclose = () => {
                console.error("******************");
                console.error("Socket closed");
                console.error("******************");
                this.conn = null;
                this.isRefreshing = false;
                if (this.store.state.id && this.store.state.token) {
                    setTimeout(()=>{this.checkSocketConnecion()}, 10000);
                }
            }
            this.conn.onmessage = (evt) => {
                var data = evt.data;
                if (data != 'wrong thread' ){
                    data = JSON.parse(data);
                }

                switch (data.socket_action){
                    case "trigger_refresh":
                        this.sendRequest('refresh');
                        return;
                        break;
                }

                this.serverResponse(data);
            }
        } else {
            // appendLog($("<div><b>Your browser does not support WebSockets.<\/b><\/div>"))
        }
        return this.conn;

    }

    serverResponse(respData){
        if (respData == 'wrong thread'){
            respData = {thread_state: "closed"};
        }

        if (respData.lastid) {
            this.store.commit("setLastId", respData.lastid);
        }
        if (respData.messages) {
            this.store.commit("addMessages", respData.messages);
        }
        if (respData.agent) {
            this.store.commit("setAgent", respData.agent);
        }

        switch (respData.thread_state) {
            case "closed":
                this.stopThreadRefresh();
                setTimeout(() => {
                    this.store.dispatch('closeCurrentChat')
                }, 10000);
                break;
            case "queue":
                if (this.store.getters.chatWindowStatusType != 'waiting') {
                    this.store.commit('changeChatWindowStatus', 2);
                }
                this.store.commit('changeWaitingList', respData.queue);
                break;
            default:
                if (this.store.getters.chatWindowStatusType != 'active') {
                    this.store.commit('changeChatWindowStatus', 3);
                }
                break;
        }
        this.store.commit('setThreadState', respData.thread_state);
    }

    createThread(group_id) {

        var data = {
            name: this.store.state.user.name,
            email: this.store.state.user.email,
            locale: this.store.state.language,
            info: null,
            referrer: window.location.href,
            survey: 'On',
            message: '',
            content_type: 'json',
            group: group_id
        };

        axios.post(
            this.baseUrl + 'client.php',
            qs.stringify(data)
            //,{headers: {'Set-Cookie': 'PHPSESSID=2t3f8h066gfmpcp6apqva15rs7; path=/'}}

        ).then((response) => {

            let threadInfo = response.data;

            if (threadInfo.thread && threadInfo.token) {

                this.store.commit('setId', threadInfo.thread);
                this.store.commit('setToken', threadInfo.token);
                this.store.commit('changeChatWindowStatus', 2);
                this.startThreadRefresh();

            } else {
                switch (threadInfo.error) {
                    case "inactive_operators":
                        this.store.commit('changeChatWindowStatus', 4);
                        break;
                }
            }

        });

    }

    closeThread() {
        var data = {
            act: 'close',
            thread: this.store.state.id,
            token: this.store.state.token,
            lastid: this.store.state.lastId,
            user: true
        };
        this.stopThreadRefresh();
        if(!this.store.state.id || !this.store.state.token){
            this.setThreadClosed();
            return Promise.resolve();
        }

        return axios.post(
            this.baseUrl + 'thread.php?content_type=json&t=close',
            qs.stringify(data)
        ).then((response) => {
            var data = response.data;
            if (data.success) {
                this.setThreadClosed();
            }
            else {
                this.startThreadRefresh();
            }
        });

    }

    setThreadClosed() {
        this.store.commit("closeChat");
        if (this.conn){
            this.conn.close();
        }
    }

    startThreadRefresh() {
        if (this.store.state.id && this.store.state.token) {
            this.checkSocketConnecion();
        }

        if (this.threadRefreshCallback) {
            this.stopThreadRefresh();
        }
        this.threadRefreshCallback = setInterval(() => {
            store.http.refreshThread();
        }, 1000);
    }

    stopThreadRefresh() {
        if (this.threadRefreshCallback) {
            clearTimeout(this.threadRefreshCallback);
        }
    }

    getChatGroups(group_ids) {
        var data = this.getThreadData('getGroups');
        data.group_ids = group_ids;

        return axios.post(
            this.baseUrl + 'groups.php?content_type=json&t=getGroups',
            qs.stringify(data)
        ).then((response) => {
            var groups = response.data;
            this.store.commit("setChatTypes", groups);
        }).catch(() => {
            this.store.commit("setChatTypes", []);
        });
    }

    sendOfflineMessage(message){
        var data = this.convertChatMessage(message);
        data.content_type = 'json';
        data.option = 'send-message';
        return axios.post(
            this.baseUrl + 'client.php',
            qs.stringify(data)
        );

    }

    shareUrlWithAgent(url){
        this.sendRequest('shareUrl', url )
    }

    convertChatMessage(message){
        let result = {
            'clName' : message.name,
            'clMail' : message.email,
            'clPhone' : message.phone,
            'clenquiry' : message.subject,
            'clmessage' : message.message,
        };
        return result;
    }
}

export default ChatService;
